import { supporterInvoicesQuery } from "@/api/invoice";
import { DepositMatchingCard } from "@/pages/admin/supporters/[supporterId]/DepositMatchingCard";
import { StatsView } from "@/pages/admin/supporters/[supporterId]/StatsView";
import { InvoiceTable } from "@/pages/supporter/financial-reports/invoices/InvoiceTable";
import { MemberFeeDiscounts } from "@/pages/supporter/settings/billing/MemberFeeDiscounts";
import { Flex } from "@givenwell/components";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, toMinValue } from "valibot";

export const Route = createFileRoute("/admin/supporters/$supporterId/billing")({
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
  }),
  component: WalletPage,
  beforeLoad: () => ({
    breadcrumb: "Billing",
  }),
});

function WalletPage() {
  const { supporterId } = Route.useParams();
  const { page, "page-size": pageSize } = Route.useSearch();

  const { data: invoices } = useSuspenseQuery(supporterInvoicesQuery(supporterId, page, pageSize));

  return (
    <Flex css={{ gap: 8, flexDir: "column" }}>
      <Flex css={{ gap: 8, flexWrap: "wrap", alignItems: "stretch" }}>
        <StatsView supporterId={supporterId} />
        <MemberFeeDiscounts supporterId={supporterId} />
        <DepositMatchingCard supporterId={supporterId} />
      </Flex>
      <InvoiceTable supporterId={supporterId} invoices={invoices} />
    </Flex>
  );
}
